import * as z from 'zod';
import { suretyBondIssuanceMethodSchema, fileExtensionSchema, fileTypeSchema, suretyBondFormTypeSchema } from '../../../../enums.mjs';
import { suretyBondFormId, fileId, suretyBondFormTemplateId } from '../../../../types/opaque.mjs';
import { Data } from '../../../../types/surety/bond-form/surety-bond-form.data.mjs';
import { Upload as Upload$1, Approve as Approve$1 } from './contract/contract-surety-bond-form.dto.mjs';
import * as contractSuretyBondForm_dto from './contract/contract-surety-bond-form.dto.mjs';
export { contractSuretyBondForm_dto as Contract };
import * as adminIssuedSuretyBondForm_dto from './admin-issued-surety-bond-form.dto.mjs';
export { adminIssuedSuretyBondForm_dto as Issued };

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = Data.schema
            .and(z.object({
            id: suretyBondFormId,
            issuanceMethod: suretyBondIssuanceMethodSchema.optional(),
            approvedBeforeIssuance: z.boolean(),
            filledWithAdornmentsFileId: fileId.optional(),
        }))
            .and(z.discriminatedUnion("source", [
            z.object({
                source: z.literal("library"),
                templateId: suretyBondFormTemplateId,
                template: z.string(),
            }),
            z.object({
                source: z.literal("upload"),
                uploadedFiles: z.array(z.object({
                    id: fileId,
                    name: z.string(),
                    extension: fileExtensionSchema,
                    types: z.array(fileTypeSchema),
                })),
            }),
        ]));
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Update;
(function (Update) {
    (function (Request) {
        const templateSchema = z.object({
            templateId: suretyBondFormTemplateId,
            bondFormType: z.literal(null),
            uploadedFileIds: z.array(fileId).min(0).max(0),
        });
        const uploadedFileSchema = z.object({
            templateId: z.literal(null),
            uploadedFileIds: z.array(fileId).nonempty(),
            bondFormType: suretyBondFormTypeSchema,
        });
        const partialSchema = z.object({
            templateId: z.literal(null),
            bondFormType: z.literal(null),
            uploadedFileIds: z.array(fileId).min(0).max(0),
        });
        Request.schema = z.union([templateSchema, uploadedFileSchema, partialSchema]);
    })(Update.Request || (Update.Request = {}));
})(Update || (Update = {}));
var Upload;
(function (Upload) {
    (function (AgentIssue) {
        (function (Request) {
            Request.schema = z.discriminatedUnion("suretyType", [
                Upload$1.AgentIssue.Request.schema,
            ]);
        })(AgentIssue.Request || (AgentIssue.Request = {}));
    })(Upload.AgentIssue || (Upload.AgentIssue = {}));
    (function (Request) {
        Request.schema = z.discriminatedUnion("suretyType", [Upload$1.Request.schema]);
    })(Upload.Request || (Upload.Request = {}));
})(Upload || (Upload = {}));
var Approve;
(function (Approve) {
    (function (AgentIssue) {
        (function (Request) {
            Request.schema = z.discriminatedUnion("suretyType", [
                Approve$1.AgentIssue.Request.schema,
            ]);
        })(AgentIssue.Request || (AgentIssue.Request = {}));
    })(Approve.AgentIssue || (Approve.AgentIssue = {}));
    (function (Request) {
        Request.schema = z.discriminatedUnion("suretyType", [Approve$1.Request.schema]);
    })(Approve.Request || (Approve.Request = {}));
})(Approve || (Approve = {}));

export { Approve, Get, Update, Upload };
